export default "__VITE_ASSET__8f0ad7c1__"